if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      // Unico punto in cui si decide `properties[preorder]`: prima dell'aggiunta, con dati freschi
      // della variante realmente aggiunta. Non rifiuta mai: in caso di problemi l'acquisto prosegue.
      this.applyPreorderProperty(formData)
        .then(() => {
          config.body = formData;
          return fetch(`${routes.cart_add_url}`, config);
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    // Imposta o rimuove `properties[preorder]` nel FormData in base allo stato reale della variante.
    // La key (`preorder`) e il valore (traduzione `products.product.in_preorder`) restano quelli letti
    // dalla mail di conferma ordine: non modificarli.
    // Se lo stato non e' disponibile (nessun data-product-url, rete, timeout) NON si blocca l'acquisto:
    // resta il valore gia' presente nel form (input hidden lato server) e si logga un warning.
    async applyPreorderProperty(formData) {
      const FIELD = 'properties[preorder]';
      const TIMEOUT_MS = 1500;
      const productUrl = this.dataset.productUrl;
      const variantId = formData.get('id');
      if (!productUrl || !variantId) return;

      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
      try {
        // Parametro "_" per evitare risposte in cache: serve la giacenza di adesso.
        const url = `${productUrl.split('?')[0]}?view=preorder-state&_=${Date.now()}`;
        const response = await fetch(url, { signal: controller.signal, cache: 'no-store', credentials: 'same-origin' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const state = await response.json();

        const variant = (state.variants || []).find((v) => String(v.id) === String(variantId));
        if (!variant) throw new Error(`variante ${variantId} non trovata nello stato`);

        if (variant.preorder) {
          const message = window.variantStrings && window.variantStrings.inPreorder;
          if (!message) throw new Error('messaggio pre-order non disponibile (window.variantStrings.inPreorder)');
          formData.set(FIELD, message);
        } else {
          formData.delete(FIELD); // in stock: nessuna proprieta', mai il campo vuoto
        }
      } catch (e) {
        console.warn('[preorder] stato pre-order non disponibile, uso il valore presente nel form:', e);
        // Se il fallback e' un campo vuoto non va inviato.
        if (formData.get(FIELD) === '') formData.delete(FIELD);
      } finally {
        clearTimeout(timer);
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
